import { ref, computed, onMounted } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

export function useCampaignDashboard() {
  const store = useStore();

  const activeTab = ref('whatsapp');
  const statusFilter = ref(null);
  const searchQuery = ref('');
  const selectedCampaign = ref(null);
  const isDetailOpen = ref(false);

  const uiFlags = useMapGetter('campaigns/getUIFlags');
  const isFetching = computed(() => uiFlags.value.isFetching);

  const filteredCampaigns = computed(() => {
    return store.getters['campaigns/getFilteredCampaigns']({
      type: activeTab.value,
      status: statusFilter.value,
      search: searchQuery.value,
    });
  });

  const setTab = tab => {
    activeTab.value = tab;
    statusFilter.value = null;
  };

  const setStatusFilter = status => {
    statusFilter.value = statusFilter.value === status ? null : status;
  };

  const selectCampaign = campaign => {
    selectedCampaign.value = campaign;
    isDetailOpen.value = true;
  };

  const closeDetail = () => {
    isDetailOpen.value = false;
    selectedCampaign.value = null;
  };

  const refresh = () => {
    store.dispatch('campaigns/get');
    store.dispatch('campaigns/fetchStats');
  };

  onMounted(() => {
    store.dispatch('campaigns/get');
    store.dispatch('campaigns/fetchStats');
  });

  return {
    activeTab,
    statusFilter,
    searchQuery,
    selectedCampaign,
    isDetailOpen,
    isFetching,
    filteredCampaigns,
    setTab,
    setStatusFilter,
    selectCampaign,
    closeDetail,
    refresh,
  };
}
